import '.d{display:flex;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dw{background:var(--palette-white);}.ssr-plugin'
import '.ai{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.fh{justify-content:stretch;}.ssr-plugin'
import '.b0{position:sticky;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.b5{z-index:10;}.ssr-plugin'
import '.fi{padding-block:1rem;}.ssr-plugin'
import '.fj{height:3rem;}.ssr-plugin'
import '.bh{justify-content:space-between;}.ssr-plugin'
import '.c0{flex-wrap:wrap;}.ssr-plugin'
import '.fl{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.f7{margin-top:2rem;}.ssr-plugin'
import '.h8{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a8 ab e dw"
      >
        <div className="ai d r ab e"
        >
          <div className="ag d e fh b0 b1 b5"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fi fj d bh r c0"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fl d e a8 f7 h8 ag"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
